export default [
  {
    key: 'id',
    label: '',
    _style: 'width:1%',
    sorter: false,
    filter: false,
    slot: true,
  },
  {
    key: 'photo',
    label: '',
    _style: 'min-width:50px',
    sorter: false,
    filter: false,
    slot: true,
  },
  {
    label: 'ユーザ名',
    key: 'account_name',
    _style: 'min-width:100px',
  },
  {
    label: '性別',
    key: 'gender',
    _style: 'min-width:50px',
  },
  {
    label: '年齢',
    key: 'birthday',
    _style: 'min-width:40px;',
  },
  { label: 'ステータス', key: 'status_name', _style: 'min-width:50px;' },
  {
    label: '備考',
    key: 'admin_note',
    _style: 'min-width:200px;',
    slot: true,
    sorter: false,
  },
  {
    label: '体重変位',
    key: 'compare_weight',
    _style: 'min-width:50px;',
  },
  {
    label: '体脂肪変位',
    key: 'compare_BodyFatRate',
    _style: 'min-width:50px;',
  },
  {
    label: '最終計測日時',
    key: 'weight_at',
    _style: 'min-width:50px;',
  },
  { label: '体重', key: 'weight', _style: 'min-width:50px;' },
  { label: 'BMI', key: 'BMI', _style: 'min-width:50px;' },
  {
    label: '体脂肪率',
    key: 'body_fat_rate',
    _style: 'min-width:50px;',
  },
  {
    label: '除脂肪体重',
    key: 'lean_body_weight',
    _style: 'min-width:50px;',
  },
  {
    label: '皮下脂肪',
    key: 'subcutaneous_fat',
    _style: 'min-width:50px;',
  },
  {
    label: '内臓脂肪',
    key: 'visceral_fat',
    _style: 'min-width:50px;',
  },
  {
    label: '体水分率',
    key: 'body_water_rate',
    _style: 'min-width:50px;',
  },
  {
    label: '骨格筋',
    key: 'muscle_rate',
    _style: 'min-width:50px;',
  },
  {
    label: '総筋肉量',
    key: 'muscle_mass',
    _style: 'min-width:50px;',
  },
  { label: '骨量', key: 'bone_mass', _style: 'min-width:50px;' },
  {
    label: 'タンパク質',
    key: 'protein',
    _style: 'min-width:50px;',
  },
  { label: '基礎代謝', key: 'BMR', _style: 'min-width:50px;' },
  {
    label: '体内年齢',
    key: 'metabolic_age',
    _style: 'min-width:50px;',
  },
]
